export const TIME_CONSTANT = 325
export const CAROUSEL_MARGINS = 94



// WEBPACK FOOTER //
// ./containers/BuildingsCarousel/components/KineticScrolling/constants.js